const boxShadows: { [key: string]: string } = {
  panelBox: '0px 4px 8px 0px rgba(0, 0, 0, 0.07)',
};

export default boxShadows;
